import React, {Component} from 'react';
import _ from 'lodash';
import {connect} from 'react-redux';
import {Card, Checkbox, Dropdown, Input, Loader, Table} from 'semantic-ui-react';
import {Actions} from '../../../../../common/actions';
import {pageSizes} from '../../../../../common/constants/lists';
import TablePaginator from '../../../../../common/components/tablePaginator';
import './locationsData.scss';

class LocationsData extends Component {
  constructor(props) {
    super(props);

    this.onFilterChange = this.onFilterChange.bind(this);
    this.onPageSizeClick = this.onPageSizeClick.bind(this);
    this.onPageClick = this.onPageClick.bind(this);
    this.isLocationAssignedToZone = this.isLocationAssignedToZone.bind(this);
    this.isLocationsFilteredListAssignedToZone =
      this.isLocationsFilteredListAssignedToZone.bind(this);
    this.onLocationHeaderCheckboxChange =
      this.onLocationHeaderCheckboxChange.bind(this);
  }

  componentDidMount() {
    this.props.changeLocationsTextFilter('');
    this.props.changeLocationsListPage(0);
    this.props.fetchLocationsList();
  }

  onFilterChange(event) {
    this.props.changeLocationsTextFilter(event.target.value);
    this.props.filterLocations(event.target.value);
  }

  onPageClick(value) {
    this.props.changeLocationsListPage(value);
  }

  onPageSizeClick(event, data) {
    this.props.changeLocationsListPageSize(data.value);
  }

  isLocationAssignedToZone(location) {
    const {assignedLocations} = this.props;
    return _.indexOf(assignedLocations, location) !== -1;
  }

  isLocationsFilteredListAssignedToZone() {
    const {assignedLocations, filteredList} = this.props;

    return (
      filteredList.length > 0 &&
      _.every(
        filteredList,
        (element) => _.indexOf(assignedLocations, element.location) !== -1
      )
    );
  }

  onLocationItemCheckboxChange(id, value) {
    const {assignedLocations} = this.props;
    const checked = document.getElementById(id).checked;
    const locationAssigned = _.indexOf(assignedLocations, value) !== -1;
    if (checked && !locationAssigned) {
      this.props.changeAssignedLocations([...assignedLocations, value]);
    } else if (!checked && locationAssigned) {
      this.props.changeAssignedLocations(_.without(assignedLocations, value));
    }
  }

  onLocationHeaderCheckboxChange(event, value) {
    const {assignedLocations, filteredList} = this.props;

    if (value.checked) {
      this.props.changeAssignedLocations(
        _.union(
          assignedLocations,
          _.map(filteredList, (element) => element.location)
        )
      );
    } else {
      this.props.changeAssignedLocations(
        _.difference(
          assignedLocations,
          _.map(filteredList, (element) => element.location)
        )
      );
    }
  }

  renderTableBody() {
    const {loading} = this.props;

    if (loading) {
      return (
        <Table.Body>
          <Table.Row>
            <Table.Cell colSpan='100%'>
              <Loader active inline='centered' />
            </Table.Cell>
          </Table.Row>
        </Table.Body>
      );
    }
    return <Table.Body>{this.renderLocations()}</Table.Body>;
  }

  renderLocations() {
    const {locations} = this.props;

    if (!locations.length) {
      return (
        <Table.Row>
          <Table.Cell textAlign='center' colSpan={13}>
            No hay datos disponibles
          </Table.Cell>
        </Table.Row>
      );
    }

    return locations.map((element, index) => {
      return (
        <Table.Row key={index}>
          <Table.Cell textAlign='center'>
            <Checkbox
              id={`location-checkbox-${index}`}
              checked={this.isLocationAssignedToZone(element.location)}
              onChange={() => this.onLocationItemCheckboxChange(
                `location-checkbox-${index}`,
                element.location
              )}
            />
          </Table.Cell>
          <Table.Cell textAlign='center'>{element.location}</Table.Cell>
          <Table.Cell textAlign='center'>
            {element.pickingZoneName ? element.pickingZoneName : 'Sin zona'}
          </Table.Cell>
        </Table.Row>
      );
    });
  }

  renderTableFooter() {
    const {pageSize, locationsCount, pageNumber, loading} = this.props;

    if (loading || locationsCount <= pageSize) {
      return null;
    }

    return (
      <Table.Footer>
        <Table.Row textAlign='center'>
          <Table.HeaderCell colSpan='100%'>
            <div className='table-pagination'>
              <span className='page-sizer'>
                <strong>Items por página</strong>
                <Dropdown
                  selection
                  upward
                  compact
                  value={pageSize}
                  options={pageSizes}
                  onChange={this.onPageSizeClick}
                />
              </span>
              <TablePaginator
                itemsCount={locationsCount}
                itemsPerPage={pageSize}
                selectedPage={pageNumber}
                onOptionClick={this.onPageClick}
              />
            </div>
          </Table.HeaderCell>
        </Table.Row>
      </Table.Footer>
    );
  }

  render() {
    const {loading, filterText} = this.props;

    return (
      <div className='locations-data-list'>
        <Card raised fluid>
          <div className='title-bar'>
            <div className='title'>
              <h4>Filtro de ubicaciones</h4>
              <div className='title-bar-actions'>
                <Input
                  icon='search'
                  placeholder='Buscar'
                  value={filterText}
                  onChange={this.onFilterChange}
                />
              </div>
            </div>
          </div>
        </Card>

        <Card fluid raised>
          <Table striped>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell textAlign='center'>
                  <Checkbox
                    label='Asignado'
                    checked={this.isLocationsFilteredListAssignedToZone()}
                    onChange={this.onLocationHeaderCheckboxChange}
                    disabled={loading}
                  />
                </Table.HeaderCell>
                <Table.HeaderCell textAlign='center'>
                  Ubicación
                </Table.HeaderCell>
                <Table.HeaderCell textAlign='center'>
                  Nombre de la zona
                </Table.HeaderCell>
              </Table.Row>
            </Table.Header>
            {this.renderTableBody()}
            {this.renderTableFooter()}
          </Table>
        </Card>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'loading': state.locations.loading,
    'locations': state.locations.page,
    'filterText': state.locations.filterText,
    'pageNumber': state.locations.pageNumber,
    'pageSize': state.locations.pageSize,
    'locationsCount': state.locations.filteredList.length,
    'filteredList': state.locations.filteredList,
    'assignedLocations': state.form.zones.values.locations,
    'menuSelected': state.menu.selected,
    'permissions': state.session.permissions,
  };
};

const {
  fetchLocationsList,
  filterLocations,
  changeLocationsTextFilter,
  changeLocationsListPage,
  changeLocationsListPageSize,
  changeAssignedLocations,
} = Actions;

export default connect(mapStateToProps, {
  fetchLocationsList,
  filterLocations,
  changeLocationsTextFilter,
  changeLocationsListPage,
  changeLocationsListPageSize,
  changeAssignedLocations,
})(LocationsData);
